import { collection, onSnapshot, query, where } from "firebase/firestore";
import { firestore } from "../../../configs/FirebaseConfig";
import useSWRSubscription from "swr/subscription";
import { FIRESTORE_ORDER_DELIVERIES_TABLE, FIRESTORE_REGIONS_TABLE } from "../../../constants/FirestoreConstant";
import { COMPANY_COUNTRY_CODE } from "../../../constants/CompanyConstants";
import dayjs from "dayjs";

export function useOrderDeliveries(dateRange = null) {
  const { data, error } = useSWRSubscription(
    `orderDeliveries-${dateRange ? `${dateRange[0]}-${dateRange[1]}` : "null"}`,
    (key, { next }) => {
      try {
        if (!dateRange || !dateRange[0] || !dateRange[1]) {
          next(null, []);
          return () => {};
        }

        // Convert date range to YYYY-MM-DD format for querying
        const startDate = dayjs(dateRange[0]).format("YYYY-MM-DD");
        const endDate = dayjs(dateRange[1]).format("YYYY-MM-DD");

        // Build Firestore query for orderDeliveries filtered by farmorderDeliveryDate
        // Removed the deliveryStatus filter to include pending deliveries
        const deliveriesQuery = query(
          collection(
            firestore,
            `${FIRESTORE_REGIONS_TABLE}/${COMPANY_COUNTRY_CODE}/${FIRESTORE_ORDER_DELIVERIES_TABLE}`,
          ),
          where("farmorderDeliveryDate", ">=", startDate),
          where("farmorderDeliveryDate", "<=", endDate),
        );

        // Listen to orderDeliveries with real-time updates
        const unsubscribeDeliveries = onSnapshot(
          deliveriesQuery,
          (deliveriesSnapshot) => {
            try {
              const deliveries = deliveriesSnapshot.docs.map((doc) => ({
                ...doc.data(),
                orderId: doc.id, // The document ID is the same as the order ID
              }));

              next(null, deliveries);
            } catch (err) {
              next(err, null);
            }
          },
          (error) => {
            next(error, null);
          },
        );

        return () => {
          unsubscribeDeliveries();
        };
      } catch (error) {
        next(error, null);
      }
    },
  );

  return {
    data,
    error,
    loading: !data && !error,
  };
}
